import { styled } from '@mui/material/styles'

import { Item, NoItem } from './Item'

const Container = styled('div')(() => ({
  paddingTop: '1rem',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative', // Add position relative for positioning FeedItemForm
  zIndex: 0, // Set a z-index value to create a stacking context
  paddingBottom: '4rem', // Add padding to the bottom of the container to prevent FeedItemForm from overlapping the last item
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  '@media (min-width: 1080px)': {
    maxWidth: '900px'
  }
}))

const Items = ({ items, isFilterByLiked }) => {
  return (
    <Container>
      {items &&
        items?.map((r) => {
          return <Item item={r} key={r._id} />
        })}
      {items.length === 0 && (
        <NoItem isFilterByLiked={isFilterByLiked}/>
      )}
    </Container>
  )
}

export { Items }
